/** Keep authentication destinations inside this application and away from login loops. */
export function normalizeReturnUrl(value: string | null | undefined): string {
  const fallback = '/dashboard';
  if (!value || !value.startsWith('/') || value.startsWith('//') || hasUnsafeCharacter(value)) {
    return fallback;
  }
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    let path = url.pathname;
    for (let index = 0; index < 3; index++) {
      if (/%(?:2f|5c)/i.test(path) || hasUnsafeCharacter(path)) return fallback;
      const decoded = decodeURIComponent(path);
      if (decoded === path) break;
      path = decoded;
    }
    // Angular matches the route before its optional matrix parameters.
    const firstSegment = path.split('/')[1]?.split(';')[0];
    if (firstSegment === 'sign-in' || firstSegment === 'login') {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

function hasUnsafeCharacter(value: string): boolean {
  return [...value].some(
    (character) =>
      character === '\\' || character.charCodeAt(0) <= 31 || character.charCodeAt(0) === 127,
  );
}
